import { Injectable } from '@angular/core';
import { BaseService, IKeyValuePair, AuthorizationType } from './base.service';
import { Observable } from 'rxjs';
import { Constants } from '../../models/constants.model';
import { IResourcePublicService } from '../models/i-resource-public-service';
import { Device } from '../../models/device.model';

@Injectable({
    providedIn: 'root'
})
export class DevicePublicService extends BaseService<Device> implements IResourcePublicService {

    protected endpointUri = 'RoomReservation/Devices';

    protected get authorizationType() {
        return AuthorizationType.Anonymous;
    }

    getAll(): Observable<Device[]> {
        throw new Error('Method not implemented.');
    }

    get(id: string): Observable<any> {
        return this.getRequest(id);
    }

    add(entity: Device): Observable<any> {
        throw new Error('Method not implemented.');
    }
    update(entity: Device): Observable<any> {
        throw new Error('Method not implemented.');
    }
    delete(id: string): Observable<{}> {
        throw new Error('Method not implemented.');
    }

    getDevices(parameters: IKeyValuePair<string, string>[]): Observable<any> {
        return this.getAllRequest(this.endpointUri, parameters);
    }

    getOccupancies(parameters: IKeyValuePair<string, string>[]): Observable<any> {
        return this.getAllRequest(this.endpointUri + '/Occupancies', parameters);
    }

    /**
     * Get TimeSlots (Slot available according to Ressourcenkalender)
     *
     * @param {number} idRessource
     * @param {number} from (unixtime)
     * @param {number} to (unixtime)
     * @returns {Observable<any>}
     * @memberof DevicePublicService
     */
    getTimeSlots(idRessource: number, from: number, to: number): Observable<any> {
        return this.getAllRequest(this.endpointUri + '/' + String(idRessource) + '/TimeSlots',
            [
                { key: Constants.UrlParams.DateFrom, value: String(from) },
                { key: Constants.UrlParams.DateTo, value: String(to) }
            ]);
    }
}
